import React, { useState, useEffect }  from 'react';
import styles from './phonepadbutton.css';
import PhonePad from '../../phonepad/index';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@momentum-ui/react';
import {i18n} from '../../../utils/GadgetUtils';
import ComponentsUtil from '../../../utils/ComponentsUtil';
import AlertModal from '../alertmodal';


const PhonepadButton = (props) => {

	const [showPhonePad, setShowPhonePad] = useState(false);
    const [buttonClick, setbuttonClick] = useState(false);
    const [continueWithoutSave, setContinueWithoutSave] = useState(false);

    var unsaved = props.unsavedChanges;
    var target;

    const togglePhonePad = (evt) => {
        target = evt.target.id;
        evt.stopPropagation();
        evt.preventDefault();
        if(props.unsavedChanges === false || continueWithoutSave === true){
            setContinueWithoutSave(false);
            setShowPhonePad(!showPhonePad);
            // This is needed only for FIREFOX / EDGE.
            if (!showPhonePad) { ComponentsUtil.setFocusByElementID(target); }
        }
        else{
            setbuttonClick(true);
            evt.preventDefault();
        }
    }

useEffect(() => {
    if (props.transferError) {
        setShowPhonePad(true);
    }
 }, [props.transferError]);



useEffect(() => {
    if(continueWithoutSave === true){
        setShowPhonePad(!showPhonePad);
        // This is needed only for FIREFOX / EDGE.
        if (!showPhonePad) { ComponentsUtil.setFocusByElementID(target); }
        setContinueWithoutSave(false);
    }
}, [continueWithoutSave])

    const onDismissPhonePad = () => {
        setShowPhonePad(false);
    }


	return (
		<div>
            <Tooltip tooltip={i18n.getMsg('gadget.imi.operation.transfer.blocked')}
                className={`${props.isForceWrapUp ? `${styles.showTooltip}`  : `${styles.hideTooltip}` }`} 
                popoverProps={{ direction: 'bottom-center' }}
                tooltipTrigger='MouseEnter'>
			<Button
                className={`${styles.taskHeaderButton} ${props.isForceWrapUp ?  `${styles.buttonBlockedPointer}` : '' }`}
                active={showPhonePad}
                children={[
                    <md-icon key={`transfer-${props.id}`} name='icon-assign-privilege_16'
                        style={{ marginRight: "8px", marginTop: "12px", marginBottom: "12px",
                        display: `${props.transferInProgress ? "none" : "block" }` }}/>,
                    <md-spinner key={`loading-${props.id}`} size='16' class={styles.transferButtonSpinner}
                        style={{ marginRight: "8px",
                        display: `${props.transferInProgress ? "block" : "none"}` }}/>,,
                    <span key={`transfer-label-${props.id}`}>{i18n.getMsg('gadget.imi.operation.TRANSFER')}</span>
                    ]}
                ariaLabel={i18n.getMsg('gadget.imi.operation.Transfer.arialabel')} tabIndex="0"
                id={props.id}
                disabled={props.disableTransfer || props.endOperationInProgress || (props.scriptSelectors && props.scriptSelectors.options && props.scriptSelectors.options.length === 0) }
                size={40}
                onClick={togglePhonePad}/>
            </Tooltip>
            {props.isForceWrapUp ? null : <PhonePad
                show={showPhonePad}
                onDismiss={onDismissPhonePad}
                {...props}
                cachedKeypadContentKey="CC-KEYPAD_CONTENT"/>
			}
            {buttonClick && <AlertModal unSavedChanges={props.unsavedChanges} ButtonClick={buttonClick} setButtonClick={setbuttonClick} continueWithoutSave={continueWithoutSave} setContinueWithoutSave={setContinueWithoutSave} /> }

		</div>
	);
}

PhonepadButton.propTypes = {
	/* Id of the element where phonepad will be positioned */
	id: PropTypes.string.isRequired,
	disableButtons: PropTypes.bool

};

PhonepadButton.defaultProps = {
	/* Id of the element where phonepad will be positioned */
	id: '',
	disableButtons: false
};

export default PhonepadButton;
